import { render, staticRenderFns } from "./BuyOrdersFinalize.vue?vue&type=template&id=e3915294&"
import script from "./BuyOrdersFinalize.vue?vue&type=script&lang=js&"
export * from "./BuyOrdersFinalize.vue?vue&type=script&lang=js&"
import style0 from "./BuyOrdersFinalize.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports